import request from '../request'

export default {
  getDemarcaciones() {
    return request.get('demarcacion')
  }
}
